<template>
    <section class="wrap-config">
      <header>
        <ul>
          <span v-for="(item, index) in tabList" :key="index">
            <li
              @click="tabName = item.name;"
              :class="item.name == tabName ? 'act' : ''"
            
            >
              <span v-text="item.title"></span>
            </li>
          </span>
        </ul>
        <div >
  
        </div>
      </header>
      <main >
        <component
          :is="tabName"
        ></component>
      </main>
    
    </section>
  </template>
  
  <script>
  export default {
    data() {
      return {
        // tab切换菜单项
        tabList: [
          {
            title: "包",
            name: "package",
          },
          {
            title: "库",
            name: "library",
          },
          
        ],
        // 当前tab页名
        tabName: "package",

        //点击跳转标签名
        nextTab: "",
      };
    },
    components: {
        package: () => import("./wrapConfig/Package.vue"),
        library: () => import("./wrapConfig/Library.vue"),
    },
    methods: {
    },
  
  };
  </script>
  
  <style lang="scss" scoped>
  .wrap-config {
    position: relative;
    background-color: #fff;
    border-radius: 4px;
    margin: -8px;
    header {
      position: absolute;
      z-index: 9;
      box-sizing: border-box;
      width: 100%;
      padding: 0 24px;
      //background-color: #fff;
      border-top: 1px #e4e8ec solid;
      padding-bottom: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .title {
        display: flex;
        justify-content: space-between;
        // align-items: center;
      }
      ul {
        display: flex;
        height: 80px;
        /* line-height: 62px; */
        flex-wrap: wrap;
        align-items: center;
        li {
          border-bottom: 3px solid transparent;
          padding: 0 5px;
          margin-right: 25px;
          font-size: 16px;
          //font-weight:600;
          cursor: pointer;
          white-space: nowrap;
          background-color: #fff;
          border-radius: 30px;
          width: 70px;
          height: 35px;
          display: flex;
          align-items: center;
          border: 1px solid #dbe1e7;
          justify-content: center;
          i {
            display: inline-block;
            width: 20px;
            height: 20px;
            background-repeat: no-repeat;
            background-position: center;
            vertical-align: text-bottom;
            margin-right: 10px;
          }
          &:hover {
            background-color: #ecf0fe;
          }
          &.act {
            color: #3c65f5;
            border: #3c65f5 1px solid;
            background-color: #edeffb;
          }
        }
      }
    }
    main {
      position: absolute;
      // width: calc(100% - 40px);
      width: calc(100% - 0px);
      // background-color: #fff;
      padding: 70px 20px 20px;
    }
    .clear-float {
      clear: both;
    }
  }

  </style>
  